const objectHasProperty = (
  obj: unknown,
  property: string | number,
): boolean => {
  return Object.prototype.hasOwnProperty.call(obj, property);
};

export default objectHasProperty;
